export default __webpack_public_path__ + "static/20211202_155859-74b484dd867dd26d7dfa86bed52c2dfb.jpeg";